import { useLocation, useNavigate } from "react-router-dom";

import { useGame } from "../header/GameContext";
import KeywordCheck from "./keywordCheck";
import ChatBoxType2 from "../chat/chatType2";
import Header from "../header/header";
import Wrong from "../wrong/wrong";
import Hint from "../hint/hint";
import { useState, useEffect, useRef } from "react";

import "./quiz.css";

/*
1. 퀴즈 정답 데이터 --> correctAnswerDatas 
2. 힌트 여부 ( 있음 었음 ) 
2-1. 있다면 데이터 값 전달 받기 ? vs 데이터값 저장 ? (없다면 무시)
3. 컨포넌트 이동경로 정답이라면 -> 정답 컨퍼넌트 / 오답이라면 오답 컨퍼넌트 / 힌트라면 힌트 컨퍼넌트

*/
export default function Keyword({
  answerData,
  DateVal,
  titImgclassName,
  hintWhetherIs,
  hintContent,
  timerMode = "run",
  showHeader = true,
}) {
  const { startTimer, pauseTimer } = useGame();

  /* =========================
         타이머 제어 (핵심)
      ========================= */
  useEffect(() => {
    if (timerMode === "run") {
      startTimer();
    } else {
      pauseTimer();
    }
  }, [timerMode]);
  //const navigate = useNavigate();
  const [showWrong, setShowWrong] = useState(false);
  const [hintWhether, setHintWhether] = useState(false);
  const [showHint, setShowHint] = useState(false);

  //state
  const { state } = useLocation();
  const navigate = useNavigate();
  if (state) {
    const {
      answerDataState,
      DateValState,
      titImgclassNameState,
      hintWhetherIsState,
      hintContentState,
    } = state;
    answerData = answerDataState;
    DateVal = DateValState;
    titImgclassName = titImgclassNameState;
    hintWhetherIs = hintWhetherIsState;
    hintContent = hintContentState;
  }

  const chatRef = useRef(null);

  useEffect(() => {
    setHintWhether(hintWhetherIs);
  }, [hintWhetherIs]);
  return (
    <div id="content">
      <Header initialTime={1800} missionCount={3} missionTotal={8} />
      <div className="box box_con con_box1 con_pd5 con_box_c ans0001">
        <div className="mission_tit keywordInputTit">
          {hintWhether && (
            <a className="hint_d" onClick={() => setShowHint(true)}>
              <span className="hint_in hint_icon mr4"></span>
              <span className="hint_in hint_txt">힌트보기</span>
            </a>
          )}
        </div>

        <ChatBoxType2
          DateVal={DateVal}
          titImgClass={titImgclassName}
          ref={chatRef}
        />

        <KeywordCheck
          onWrong={() => setShowWrong(true)}
          answerData={answerData}
        />

        {showWrong && <Wrong onClose={() => setShowWrong(false)} />}
        {showHint && (
          <Hint hintContent={hintContent} onClose={() => setShowHint(false)} />
        )}
      </div>
    </div>
  );
}
